module.exports = __webpack_public_path__ + "static/media/hives-buzzing.1d9736cd.png";